module.exports = __webpack_public_path__ + "ie.116f300a.svg";